// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1008":"bb104495","2694":"33f9d25b","6511":"09a7817a","9762":"fe63049d"}[chunkId] + ".chunk.css";
};